<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-redeem-success"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-head"
                    v-if="title">
                    <div id="redeem_success_header_txt" v-html="title"></div>
                </div>
                <div class="modal-base-body"
                    v-if="msg">
                    <div id="redeem_success_msg_txt" v-html="msg"></div>
                </div>
                <div class="modal-base-footer">
                    <div id="redeem_success_btn_row"
                        :class="{'double-btn': isHaveSecondBTN}">
                        <div class="redeem-success-btn"
                            v-if="isHaveSecondBTN">
                            <SecondaryButton
                                btnId="redeem_success_cancel_btn"
                                :btnMsg="btnSecondary"
                                @clickButton="clickSecondaryBtn()" />
                        </div>
                        <div class="redeem-success-btn">
                            <PrimaryButton
                                btnId="redeem_success_ok_btn"
                                :btnMsg="btnPrimary"
                                @clickButton="clickPrimaryBtn()" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import PrimaryButton from "../../../Button/PrimaryButton.vue";
import SecondaryButton from "../../../Button/SecondaryButton.vue";
//import Util from "@/helper/Utility.js";
/**
 * @property {RedeemSuccessModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "RedeemSuccessModal",
    mixins: [LocaleMixin],
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            campaignGroup: "",
            tag: "",
            action: "redirect",
            title: "",
            msg: "",
            btnPrimary: "",
            btnSecondary: "",
            isHaveSecondBTN: false,
            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        //event
        clickSecondaryBtn: function () {
            this.controller.cbClose.sendCallback({ tag: this.tag, action: this.action });
            this.$nextTick(() => {
                this.hide();
            });
        },
        clickPrimaryBtn: function () {
            this.controller.cbAction.sendCallback({ tag: this.tag, action: this.action });
            this.$nextTick(() => {
                this.hide();
            });
        },
        //initial
        initialModal: function () {
            if (this.campaignGroup == "5"
                || this.campaignGroup == "6"
                || this.campaignGroup == "7"
                || this.campaignGroup == "default") {
                this.action = "history";
                this.isHaveSecondBTN = true;
            }
            else {
                this.action = "redirect-aia";
                this.isHaveSecondBTN = false;
            }
            this.setText();
            this.$nextTick(() => {
                this.$bvModal.show(this.modalId);
            });
        },
        //method
        setText: function () {
            var lbl = this.lbl.redeem_success.group[this.campaignGroup];
            this.title = lbl.headline;
            this.msg = lbl.message;
            this.btnPrimary = lbl.btnPrimary;
            this.btnSecondary = lbl.btnSecondary;
        },
        //modal
        show: function (config) {
            const group = config.campaignGroup != "7"
                ? config.campaignGroup
                : "default";
            this.campaignGroup = group;
            this.tag = config.tag;
            this.initialModal();
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    },
    components: { PrimaryButton, SecondaryButton }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#redeem_success_header_txt {
    color: $color-gray;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 24px;
}

#redeem_success_msg_txt {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 24px;
}

#redeem_success_btn_row {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";

.modal-redeem-success {
    @extend %modal-base;

    .modal-dialog {
        max-width: 300px;
    }

    .modal-body {
        padding: 30px 20px;
    }
}
</style>
